import { ArrowDropDown } from '@mui/icons-material';
import { Chip, MenuItem, MenuList } from '@mui/material';
import { Box } from '@mui/system';
import NeurosynthPopper from 'components/NeurosynthPopper/NeurosynthPopper';
import { SortBy, SortByEnumToString } from 'pages/Study/Study.types';
import { useRef, useState } from 'react';

const SearchSelectSortChip = (props: {
    onSelectSort: (searchBy: SortBy) => void;
    onSelectDescOrder: (descOrder: boolean) => void;
    chipLabel: string;
    descOrderChipLabel: string;
    options: SortBy[];
}) => {
    const sortByRef = useRef(null);
    const descOrderRef = useRef(null);
    const [sortByPopperIsOpen, setSortByPopperIsOpen] = useState(false);
    const [descOrderPopperIsOpen, setDescOrderPopperIsOpen] = useState(false);

    const handleSelectSortBy = (sortBy: SortBy) => {
        props.onSelectSort(sortBy);
        setSortByPopperIsOpen(false);
    };

    const handleSelectIsDescOrder = (isDescOrder: boolean) => {
        props.onSelectDescOrder(isDescOrder);
        setDescOrderPopperIsOpen(false);
    };

    return (
        <>
            <NeurosynthPopper
                anchorElement={sortByRef?.current}
                onClickAway={() => setSortByPopperIsOpen(false)}
                open={sortByPopperIsOpen}
            >
                <Box>
                    <MenuList sx={{ width: '160px' }}>
                        {props.options.map((sortBy) => (
                            <MenuItem onClick={() => handleSelectSortBy(sortBy as SortBy)} key={sortBy} value={sortBy}>
                                {SortByEnumToString[sortBy]}
                            </MenuItem>
                        ))}
                    </MenuList>
                </Box>
            </NeurosynthPopper>
            <Chip
                ref={sortByRef}
                color="primary"
                variant="filled"
                clickable
                onClick={() => setSortByPopperIsOpen(true)}
                icon={<ArrowDropDown />}
                sx={{
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    width: '170px',
                    marginLeft: '5px',
                }}
                label={props.chipLabel}
            />
            <NeurosynthPopper
                anchorElement={descOrderRef?.current}
                onClickAway={() => setDescOrderPopperIsOpen(false)}
                open={descOrderPopperIsOpen}
            >
                <Box>
                    <MenuList sx={{ width: '200px' }}>
                        <MenuItem onClick={() => handleSelectIsDescOrder(false)}>Ascending Order</MenuItem>
                        <MenuItem onClick={() => handleSelectIsDescOrder(true)}>Descending Order</MenuItem>
                    </MenuList>
                </Box>
            </NeurosynthPopper>
            <Chip
                ref={descOrderRef}
                color="primary"
                variant="filled"
                clickable
                onClick={() => setDescOrderPopperIsOpen(true)}
                icon={<ArrowDropDown />}
                sx={{
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderLeft: 0,
                    width: '80px',
                }}
                label={props.descOrderChipLabel}
            />
        </>
    );
};

export default SearchSelectSortChip;
